import { OpenAPI, request as __request } from '/src/api';
import { ProgramRecCost } from '/src/lib/models/ProgramRecCost';

export class ProgramRecCostService {
  /**
   * List Program REC Cost
   * @returns ProgramRecCost[]
   */
  public static list(): Promise<ProgramRecCost[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/programRecCosts',
    });
  }
}
